module.exports = __webpack_public_path__ + "media/packs/images/flags/MA-7fa200832c2634c8f18c277ed8ba4a62.svg";